import React from 'react'
import { Box, Grid } from '@mui/material'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useGetSolarPlantYieldQuery } from '../../../../api-services/solar/solarApi'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'
import { type EditSolarPlantComponentProps } from './EditSolarPlantForm'

const ViewPlantYieldRatios: React.FC<EditSolarPlantComponentProps> = ({ solarProject }: EditSolarPlantComponentProps) => {
  const solarProjectId = solarProject.identifier.solarProjectId
  const plantYieldApiResult = useGetSolarPlantYieldQuery({ solarProjectId })

  const isPlantYieldDataLoaded = (): boolean => {
    if (plantYieldApiResult.error != null) return false
    if (plantYieldApiResult.isLoading) return false
    if (plantYieldApiResult.isFetching) return false
    return true
  }

  const getMonthName = (month: number): string => {
    const names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    return names[month]
  }

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', flex: 10 },
    { field: 'month', headerName: 'Month', flex: 15, valueGetter: (params) => getMonthName(params.row.month) },
    { field: 'hourLocalTz', headerName: 'Hour', flex: 15 },
    { field: 'yieldRatio', headerName: 'Ratio', flex: 15 }
  ]

  return (
    <>
      <Box sx={{ pb: 4 }}>

        <Grid item md={12}>
          {plantYieldApiResult.isLoading && <LoadingComponent/>}
          {(plantYieldApiResult.error != null) && <ErrorComponent message={RtkQueryHelper.mapResponseError(plantYieldApiResult.error)}/>}

          {isPlantYieldDataLoaded() && plantYieldApiResult.data !== null && plantYieldApiResult.data !== undefined && (
            <h3>Plant Yield Ratios - {plantYieldApiResult.data.importedAtFormatted}</h3>
          )}
        </Grid>

        {isPlantYieldDataLoaded() && plantYieldApiResult.data !== null && plantYieldApiResult.data !== undefined && (
          <Grid container spacing={4}>
            <Grid item md={12}>
              <DataGrid
                rows={plantYieldApiResult.data.values}
                columns={columns}
                autoHeight={true}
                disableSelectionOnClick
                pagination
                pageSize={24}
                rowsPerPageOptions={[24]}
              />
            </Grid>
          </Grid>
        )}

      </Box>
    </>
  )
}

export default ViewPlantYieldRatios
